module.exports = __webpack_public_path__ + "static/media/intervalisherbimit.b02bba33.jpg";